import { asLanguage, type Price } from "@broadside/common";
import useTranslation from "next-translate/useTranslation";
import { formatCurrency, usePreferences } from "../preferences";
import { useCurrencyConversion } from "./currency-conversion-context";


/**
 * Converts & formats the passed `price` into the user's preferred currency.
 */
export const useConvertedPrice = (price: Price | undefined | null): string => {
	const { t, lang } = useTranslation();

	const { currency } = usePreferences();
	const { convertPrice } = useCurrencyConversion();

	if(!price) {
		return t("common:enquire-for-rate");
	}

	const converted = convertPrice(price, currency);
	return formatCurrency(asLanguage(lang), currency, converted.amount);
};
